export enum RouterPages {
  ABWESENHEITEN = 'abwesenheiten',
  ABWESENHEITEN_GENEHMIGEN = 'abwesenheiten-genehmigen',
  ABWESENHEITEN_BEANTRAGEN = 'abwesenheiten',
  EINTRITTSFORMULAR = 'eintrittsformular',
  PERSONEN = 'personen',
  SORGEBERECHTIGTE = 'sorgeberechtigte',
  SCHUELER = 'schueler',
  VERTRAG = 'vertrag',
  NACHTRAG = 'nachtrag',
  SET_PASSWORT = 'set-password',
  CHANGE_PASSWORT = 'change-password',
  ADMIN_DASHBOARD = 'admin-dashboard',
  DATENSCHUTZ = 'datenschutz',
  BUCHUNGEN = 'buchungen',
  PRODUKT_ZUWEISUNG = 'produkt-zuweisung',
  SCHULGELD = 'schulgeld',
  ESSENSGELD = 'essensgeld',
  BETREUUNG = 'betreuung',
  PARKPLATZ = 'parkplatz',
  MUSIKUNTERRICHT = 'musikunterricht',
  VORGESETZTE = 'vorgesetzte',
  EIGENE_DATEN = 'eigene-daten',
  BESCHAEFTIGUNGSGENEHMIGUNG = 'beschaeftigungsgenehmigungen',
  TICKET = 'ticket',
  GRUPPEN = 'groups',
  COMMUNICATION = 'communication',
  QUITTUNGEN = 'quittungen',
  KIND = 'kind',
  BATCH_MAILS = 'batch-mails',
  SPENDEN = 'spenden',
  IMPRESSUM = 'impressum',
  MICROSOFT_GRPPEN = 'microsoft-gruppen',
  TEACHING_ASSISTANT = 'teaching-assistant',
  INTERVIEW_ADMINISTRATION = 'interview-administration',
  WIKI = 'wiki',
}

export enum RouterQueryParams {
  CURRENT_SCHOOL = 'schule',
  ANMELDUNG = 'anmeldung',
  VERTRAG_TAB = 'vertrag-tab',
  MITARBEITER_TAB = 'mitarbeiter-tab',
  PERSON_TAB = 'person-tab',
  FILTER_SEARCH = 'filter-search',
  FILTER_SCHULE = 'filter-schule',
  FILTER_ROLLE = 'filter-rolle',
  FILTER_ALLE = 'filter-alle',
  FILTER_EINSTELLUNGSSTATUS = 'filter-einstellungsstatus',
  FILTER_ABRECHNUGSGRUPPE = 'filter-abrechnungsgruppe',
}

export const SGRoutes = {
  personUebersicht: () => `/${RouterPages.PERSONEN}`,
  personDetails: (personID: string) => `/${RouterPages.PERSONEN}/${personID}`,

  beschaeftigungsgenehmigung: (personID: string, genehmigungID: string) =>
    `/${RouterPages.PERSONEN}/${personID}/${mitarbeiterSubPages.beschaeftigungsgenehmigungen}/${genehmigungID}`,
  batchMailEditor: () => `/${RouterPages.PERSONEN}/${RouterPages.BATCH_MAILS}`,
  datenschutz: () => `/${RouterPages.DATENSCHUTZ}`,
  impressum: () => `/${RouterPages.IMPRESSUM}`,
  spenden: () => `${RouterPages.SPENDEN}`,
  setPassword: () => `/set-password`,
  changePassword: () => '/change-password',
  eintrittsformular: () => '/eintrittsformular',
  ticket: () => '/ticket',
  changeEmail: () => '/change-email',
};
